export enum UserType {
    ADM = 'ADM',
    LDM = 'LDM',
    RGU = 'RGU',
}